import { useFormikContext } from "formik";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import { couponCodeAtom, productKeyAtom } from "src/atoms";
import { useGetPriceList } from "src/hooks/api/pay/useGetPriceList";
import { useIsOciProduct } from "src/hooks/recoil/useIsOciProduct";
import { getProductFromSessionStorage } from "src/utils/storage/auth";

interface IPriceCheckerProps {
  currency: string; // 원화 정보
  setUserPerPrice: React.Dispatch<React.SetStateAction<number>>; // 사용자당 월 요금
  setUserPerPriceYear: React.Dispatch<React.SetStateAction<number>>; // 사용자당 연 요금
  setPriceType: React.Dispatch<React.SetStateAction<string>>; // 요금제

  // PAYPAL 결제시 사용
  setPlanId: React.Dispatch<React.SetStateAction<string>>;
  setPriceUid: React.Dispatch<React.SetStateAction<string>>;
}
// 현재 요금제 가격 정보 세팅
const PriceChecker = ({
  currency,
  setUserPerPrice,
  setUserPerPriceYear,
  setPriceType,
  setPlanId,
  setPriceUid,
}: IPriceCheckerProps) => {
  const { values, setFieldValue } = useFormikContext<any>();
  const [params, setParams] = useSearchParams();
  const [productKey] = useRecoilState(productKeyAtom);
  const [couponCodeInfo] = useRecoilState(couponCodeAtom);
  const { isPriceListLoading, priceList } = useGetPriceList({
    product: getProductFromSessionStorage(),
  }); // 제품별 요금제 정보
  const { priceType, licenseCount, payTerm, selectPayType } = values;
  const { isOciProduct } = useIsOciProduct();
  const isEcoProduct =
    isOciProduct && getProductFromSessionStorage() === "WRAPSODY_ECO";
  const isCash = selectPayType === "cash";
  const calcPrice = (unitPrice: number) => {
    // const count = licenseCount < 10 || licenseCount > 9999 ? licenseCount : 10;
    // let basePrice = isEcoProduct ? unitPrice * licenseCount : unitPrice * count;
    let basePrice = Math.floor(unitPrice * licenseCount);

    // if (isCash) {
    //   basePrice = basePrice * 1.1; // 부가세 추가
    // }
    basePrice = Math.floor(basePrice * 1.1); // 부가세 추가

    if (couponCodeInfo) {
      if (couponCodeInfo.discountType === "PERCENT") {
        basePrice = basePrice * (1 - couponCodeInfo.discountPrice / 100);
      } else {
        basePrice = basePrice - couponCodeInfo.discountPrice;
      }
    }
    // console.log("calcPrice", basePrice, Math.floor(basePrice), couponCodeInfo);
    // 최종적으로 소수점 제거
    if (basePrice < 0) return 0;
    else return Math.floor(basePrice);
  };
  useEffect(() => {
    if (
      currency &&
      priceList &&
      payTerm &&
      params &&
      currency &&
      priceList &&
      licenseCount
    ) {
      priceList.find((price, idx: number) => {
        if (
          price.priceType === params.get("type") &&
          price.product === productKey &&
          price.currency === currency
        ) {
          // setPayType(price.priceUid);
          // console.log("priceType", price.priceType);
          setPriceType(price.priceType);
          setUserPerPrice(price.userPerPrice);
          setUserPerPriceYear(price.userPerPriceYear);
          if (payTerm === "month") {
            // planId 세팅
            if (price?.planIdMonth) {
              setPlanId(price.planIdMonth);
              // console.log("month plan Id 세팅", price.planIdMonth);
            }
            setFieldValue("totalPrice", calcPrice(price.userPerPrice));
          } else if (payTerm === "year") {
            // planId 세팅
            if (price?.planIdYear) {
              setPlanId(price.planIdYear);
              // console.log("year plan Id 세팅", price.planIdYear);
            }
            setFieldValue("totalPrice", calcPrice(price.userPerPriceYear * 12));
          }
          // priceUid 세팅
          if (price.priceUid) {
            setPriceUid(price.priceUid);
            setFieldValue("priceUid", price.priceUid);
          }
        }
      });
    }
  }, [payTerm, params, currency, priceList, licenseCount, couponCodeInfo]);
  return null;
};

export default PriceChecker;
